// Use the browser top layer so page stacking and clipping cannot hide languages.
if (!customElements.get('header-language-picker')) {
  customElements.define('header-language-picker', class extends HTMLElement {
    connectedCallback() {
      if (!('showPopover' in HTMLElement.prototype) || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const select = this.querySelector('select');
      const trigger = this.querySelector('[popovertarget]');
      const panel = this.querySelector('[popover]');
      const buttons = [...panel.querySelectorAll('button')];
      select.hidden = true;
      select.disabled = true;
      trigger.hidden = false;
      panel.hidden = false;

      const position = () => {
        if (!panel.matches(':popover-open')) return;
        const rect = trigger.getBoundingClientRect();
        if (!rect.width || rect.bottom <= 0 || rect.top >= innerHeight) {
          panel.hidePopover();
          return;
        }
        const below = innerHeight - rect.bottom - 16;
        const above = rect.top - 16;
        const useBelow = below >= Math.min(panel.scrollHeight, 264) || below >= above;
        panel.style.maxHeight = `${Math.max(40, useBelow ? below : above)}px`;
        panel.style.left = `${Math.max(8, Math.min(rect.right - panel.offsetWidth, innerWidth - panel.offsetWidth - 8))}px`;
        panel.style.top = `${useBelow ? rect.bottom + 8 : Math.max(8, rect.top - panel.offsetHeight - 8)}px`;
      };
      panel.addEventListener('toggle', () => {
        const open = panel.matches(':popover-open');
        trigger.setAttribute('aria-expanded', String(open));
        if (open) {
          position();
          (panel.querySelector('[aria-current]') || buttons[0]).focus({ preventScroll: true });
        }
      }, options);
      panel.addEventListener('keydown', (event) => {
        const index = buttons.indexOf(document.activeElement);
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next !== undefined) {
          event.preventDefault();
          buttons[next].focus();
        }
      }, options);
      window.addEventListener('resize', position, options);
      window.addEventListener('scroll', position, { ...options, capture: true, passive: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
